import { useState } from 'react'
import { apiClubCreate } from '../server/ServiceCall'
import { AuthState } from '../store/auth'

interface Props {
  auth:        AuthState
  onCreated:   () => void   // 구단 생성 후 부모에게 알려 ClubLoad 다시 호출
  onLoggedOut: () => void
}

export default function Onboarding({ auth, onCreated, onLoggedOut }: Props) {
  const [clubName,  setClubName]  = useState('')
  const [stadium,   setStadium]   = useState('')
  const [busy,      setBusy]      = useState(false)
  const [msg,       setMsg]       = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (clubName.trim().length < 2)  { setMsg('구단명은 2자 이상'); return }
    if (stadium.trim().length  < 2)  { setMsg('홈구장 이름은 2자 이상'); return }

    setBusy(true); setMsg('')
    try {
      const r = await apiClubCreate(auth.token, clubName.trim(), stadium.trim())
      if (r.resultCode !== '00') { setMsg(r.resultMessage || '구단 생성 실패'); return }
      // ClubLoad 재호출은 부모(App)에서
      onCreated()
    } catch (err: any) {
      setMsg(err?.message || '네트워크 오류')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="onboard-wrap">
      <div className="onboard-card">
        <h1>구단 창단</h1>
        <p className="subtitle">{auth.userName} 감독, K프로 1부에 합류하시겠습니까?</p>

        <form onSubmit={handleSubmit} className="form">
          <input
            type="text"
            placeholder="구단명 (예: 효담FC)"
            value={clubName}
            onChange={e => setClubName(e.target.value)}
            disabled={busy}
            autoFocus
            maxLength={32}
          />
          <input
            type="text"
            placeholder="홈구장 이름 (예: 효담주경기장)"
            value={stadium}
            onChange={e => setStadium(e.target.value)}
            disabled={busy}
            maxLength={32}
          />
          <button type="submit" disabled={busy}>창단하기</button>
        </form>

        <div className="onboard-hints">
          <p>· 시작 자금: ₩50억</p>
          <p>· 신용등급: BBB</p>
          <p>· 시즌 시작: 2026-08-01 (K프로 1부 18팀)</p>
        </div>

        {msg && <p className="msg">{msg}</p>}

        <button className="text-link" onClick={onLoggedOut} disabled={busy}>로그아웃</button>
      </div>
    </div>
  )
}
